import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const HeroSection = () => {
  return (
    <section className="relative min-h-[70vh] flex items-center overflow-hidden bg-background">
      {/* Radial gradient background */}
      <div
        className="absolute inset-0"
        style={{
          background: `radial-gradient(ellipse 60% 50% at 40% 40%, hsl(var(--primary) / 0.06) 0%, transparent 70%)`,
        }}
      />

      {/* Grid pattern */}
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage: `linear-gradient(hsl(var(--foreground)) 1px, transparent 1px), linear-gradient(90deg, hsl(var(--foreground)) 1px, transparent 1px)`,
          backgroundSize: "72px 72px",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-16 md:pt-32 md:pb-20">
        <div className="max-w-4xl">
          {/* H1 and subtitle rendered immediately for fast LCP */}
          <p className="text-sm font-semibold tracking-widest uppercase text-muted-foreground mb-5">
            successioAI · Technologie-Arm der successio Unternehmensnachfolge
          </p>

          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-foreground leading-[1.05] mb-6">
            KI-Lösungen, die im echten Unternehmen entstehen.
          </h1>

          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mb-8 leading-relaxed">
            Wir entwickeln KI-Software in unseren eigenen operativ tätigen Unternehmen, einer
            Personalberatung und einem Online-Händler. Erst wenn sich eine Lösung dort im Alltag
            rechnet, machen wir sie extern verfügbar. DSGVO-konform, europäisch gehostet.
          </p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
              <Button asChild size="lg" className="rounded-full px-8 text-base font-semibold bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70 shadow-lg shadow-primary/20">
                <a href="https://recruiten.ai" target="_blank" rel="noopener noreferrer">
                  recruiTen.ai entdecken
                  <ArrowRight className="ml-2 w-5 h-5" />
                </a>
              </Button>
              <Button asChild size="lg" className="rounded-full px-8 text-base font-semibold bg-gradient-to-r from-secondary to-secondary/80 hover:from-secondary/90 hover:to-secondary/70 shadow-lg shadow-secondary/20">
                <a href="https://supporten.ai" target="_blank" rel="noopener noreferrer">
                  supporTen.ai entdecken
                  <ArrowRight className="ml-2 w-5 h-5" />
                </a>
              </Button>
              <Button
                asChild
                variant="outline"
                size="lg"
                className="rounded-full px-8 text-base font-semibold border-foreground/20 text-foreground hover:bg-foreground/5"
              >
                <a href="#modell">Das successio-Modell</a>
              </Button>
            </div>
          </motion.div>

          <dl className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-x-8 gap-y-6 border-t border-border pt-8 max-w-3xl">
            {[
              { k: "1 Holding", v: "successio Unternehmensnachfolge" },
              { k: "2 Betriebe", v: "The People Finding Company, Qualitado" },
              { k: "3 Technologien", v: "recruiTen.ai, supporTen.ai, targeTen.ai" },
              { k: "10x", v: "Effizienzziel je automatisiertem Prozess" },
            ].map((s) => (
              <div key={s.k}>
                <dt className="text-xl font-bold text-foreground">{s.k}</dt>
                <dd className="text-xs text-muted-foreground leading-relaxed mt-1">{s.v}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
